module.exports = __webpack_public_path__ + "img/c05_unitaquilifer_Normal_ua.f8aeaced.webp";